export const PageDetails = {
  ats: {
    id: 'ats',
    title: 'ATS',
    url: 'ats',
  },
  courses: {
    id: 'courses',
    page: 'courses',
    title: 'Manage Courses',
    url: 'ats/courses',
  },
  codecs: {
    id: 'codecs',
    page: 'codecs',
    title: 'Manage Codecs',
    url: 'codecs',
  },
  actionHistory: {
    id: 'actionHistory',
    page: 'actionHistory',
    title: 'Action History',
    url: 'actionHistory',
  },
  courseDetails: {
    id: 'courseDetails',
    page: 'courseDetails',
    title: 'Course Details',
    url: 'courseDetails',
    isHide: true,
  },
};
